module.exports = __webpack_public_path__ + "07_hair_brown.4e243556.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/07_hair_brown.png
// module id = idfK
// module chunks = 0